(() => {
	angular.module('main').controller('CampaignsController', CampaignsController);

	CampaignsController.$inject = [
		'$scope',
		'$rootScope',
		'$filter',
		'messageService',
		'promoCodesDataService',
		'validationService',
		'timeService'
	];

	function CampaignsController(
		$scope,
		$rootScope,
		$filter,
		messageService,
		promoCodesDataService,
		validationService,
		timeService
	) {
		$scope.$on('$viewContentLoaded', () => {
			$scope.campaign = {};
			$scope.isAddSpinnningWheelActive = false;

			$scope.pageRequest = {
				page: 1,
				perPage: $rootScope.paginationPerPage
					? $rootScope.paginationPerPage
					: 25,
				pageOrder: {
					predicate: 'id',
					reverse: false
				},
				search: ''
			};

			$scope.campaigns = [];
			$scope.totalItems = 0;

			getResultsPage(
				$scope.pageRequest.page,
				$scope.pageRequest.perPage
			).subscribe(data => successGetResultsPage(data));
		});

		$scope.addOrEditPromoCode = campaign => {
			$scope.add_btn_disable = true;
			$scope.isAddSpinnningWheelActive = true;

			$scope.campaign = angular.copy(campaign);
			$('#addPromoCode').modal('show');

			$scope.isAddSpinnningWheelActive = false;
			$scope.add_btn_disable = false;
		};

		$scope.submitPromoCode = campaign => {
			$scope.btn_disable = true;
			const isExistedCode = campaign.id;
			const code2save = validateCode(campaign);

			if (!code2save) {
				$scope.btn_disable = false;
				return;
			}

			let action;
			if (isExistedCode) {
				action = promoCodesDataService.updatePromoCode(code2save);
			} else {
				action = promoCodesDataService.createPromoCode(code2save);
			}

			action
				.finally(() => ($scope.btn_disable = false))
				.mergeMap(() => {
					$('#addPromoCode').modal('hide');
					messageService.showToaster('s_0', 'general', 'Promo code saved');
					return promoCodesDataService.getAllPromoCodes($scope.pageRequest);
				})
				.subscribe(
					data => successGetResultsPage(data),
					error => messageService.showDefaultErrorMessage(error)
				);
		};

		function validateCode(campaign) {
			let dateStart, dateEnd;
			const validCampaign = angular.copy(campaign);

			if (validationService.isStringEmpty(campaign.name)) {
				messageService.showToaster('e_2', 'general', 'Campaign name is empty');
				return false;
			} else if (validationService.isStringEmpty(campaign.code)) {
				messageService.showToaster('e_2', 'general', 'Promocode is empty');
				return false;
			} else if (!campaign.discount) {
				messageService.showToaster('e_2', 'general', 'Discount is empty');
				return false;
			} else if (!campaign.startDate || !campaign.endDate) {
				messageService.showToaster('e_2', 'general', 'Duration is empty');
				return false;
			} else if (campaign.discount % 1 !== 0) {
				messageService.showToaster(
					'e_2',
					'general',
					'Discount percent should be an integer'
				);
				return false;
			}

			dateStart = timeService.getDateInFormat(validCampaign.startDate, 'date');
			dateEnd = timeService.getDateInFormat(validCampaign.endDate, 'date');

			const isCorrectDate = timeService.compareDates(dateEnd, dateStart);

			if (isCorrectDate) {
				messageService.showToaster(
					'e_2',
					'general',
					'The start date must be before the end date.'
				);
				return false;
			}

			validCampaign.startDate = dateStart;
			validCampaign.endDate = dateEnd;

			return validCampaign;
		}

		// get result page

		function getResultsPage(
			pageNumber = null,
			perPage = null,
			predicate = null,
			reverse = null
		) {
			let changed = false;

			if (predicate && reverse) {
				$scope.pageRequest.pageOrder.predicate = predicate;
				$scope.pageRequest.pageOrder.reverse = reverse;
				changed = true;
			}

			if (perPage) {
				$scope.pageRequest.perPage = perPage;
				changed = true;
			}

			if (pageNumber) {
				$scope.pageRequest.page = pageNumber;
				changed = true;
			}

			if (
				$scope.pageRequest &&
				$scope.totalItems != 0 &&
				$scope.totalItems <
					($scope.pageRequest.page - 1) * $scope.pageRequest.perPage + 1
			) {
				console.log('out of page');
				$scope.pageRequest.page = 1;
			}
			if (changed) {
				return promoCodesDataService.getAllPromoCodes($scope.pageRequest);
			}
			return false;
		}

		function successGetResultsPage(data) {
			if (data && data.pageRequest) {
				$scope.pageRequest = data.pageRequest;
				$scope.pageRequest.search = $scope.pageRequest.search || '';
			}
			$scope.pageNumbers = [];
			$scope.totalItems = data ? data.total : 0;

			let pagesCount;
			pagesCount = $scope.totalItems / $scope.pageRequest.perPage;
			pagesCount = Math.ceil(pagesCount);

			for (let i = 1; i <= pagesCount; i++) {
				$scope.pageNumbers[i - 1] = i;
			}

			$scope.campaigns = angular.copy(data.results);
			if ($scope.campaigns) {
				$scope.campaigns = timeService.convertDatesToUTC(
					$scope.campaigns,
					'startDate',
					'endDate'
				);
			}
			$scope.campaign = {};
			$scope.$evalAsync();
		}

		// navigation

		$scope.order = function(predicate) {
			if (predicate) {
				$scope.pageRequest.pageOrder.reverse =
					$scope.pageRequest.pageOrder.predicate === predicate
						? !$scope.pageRequest.pageOrder.reverse
						: false;

				$scope.pageRequest.pageOrder.predicate = predicate;
			}
			$scope.campaigns = $filter('orderBy')(
				$scope.campaigns,
				predicate,
				$scope.pageRequest.pageOrder.reverse
			);
		};

		$scope.getCurrentPage = function() {
			return $scope.pageRequest.page;
		};

		$scope.perPageChanged = function(newPerPage) {
			getResultsPage(null, newPerPage).subscribe(data =>
				successGetResultsPage(data)
			);

			$rootScope.paginationPerPage = newPerPage;
		};

		$scope.goToPage = function(newPage, disabled) {
			if (!disabled) {
				getResultsPage(newPage, null).subscribe(data =>
					successGetResultsPage(data)
				);
			}
		};

		$scope.jumpBack = function(disabled) {
			if (!disabled) {
				if ($scope.pageRequest.page > 1) {
					getResultsPage($scope.pageRequest.page - 1, null).subscribe(data =>
						successGetResultsPage(data)
					);
				}
			}
		};

		$scope.jumpAhead = function(disabled) {
			if (!disabled) {
				if (
					$scope.totalItems >=
					$scope.pageRequest.page * $scope.pageRequest.perPage + 1
				) {
					getResultsPage($scope.pageRequest.page + 1, null).subscribe(data =>
						successGetResultsPage(data)
					);
				}
			}
		};

		$scope.searchRequest = search => {
			$scope.pageRequest.search = search;

			getResultsPage(
				$scope.pageRequest.page,
				$scope.pageRequest.perPage
			).subscribe(data => successGetResultsPage(data));
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/admin/campaignsController.js